import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Messages";
import getToken from "app/api/getToken";
import { IAnswerRequest } from "app/api/types";

export const ADD_ANSWER_REQUEST = "ADD_ANSWER_REQUEST";
export const ADD_ANSWER_SUCCESS = "ADD_ANSWER_SUCCESS";
export const ADD_ANSWER_FAIL = "ADD_ANSWER_FAIL";

export const addAnswer = (data: IAnswerRequest) => (dispatch: any): any => {
  dispatch({ type: ADD_ANSWER_REQUEST });

  const token = getToken();

  return api
    .addAnswer(token, data)
    .then((response: AxiosResponse) => {
      dispatch({ type: ADD_ANSWER_SUCCESS });
    })
    .catch(err => {
      dispatch({
        type: ADD_ANSWER_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
